import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Icons",
  description: "One or more icons in a row",
  tags: ["#subpage"],
  icon: "star-filled",
  flags: {
    contentWidth: true,
  },
}

export default defineBlock("content/icons-row", () => {
  if (env.admin) {
    return (
      <InnerBlocks
        allowedBlocks={["#icon"]}
        defaultBlocks={[["content/icon", {}]]}
        adminClassName={"flex flex-wrap gap-2"}
        orientation="horizontal"
        appender={{ type: "button" }}
      />
    )
  } else {
    return (
      <div className="flex flex-wrap gap-2 my-4">
        <InnerBlocks allowedBlocks={["content/icon"]} />
      </div>
    )
  }
})
